import * as React from "react";
import { Icon } from "./Icon.js";

export function ConfirmModal({
  title,
  body,
  confirmLabel,
  destructive,
  onConfirm,
  onClose,
}: {
  title: string;
  body: React.ReactNode;
  confirmLabel: string;
  destructive?: boolean;
  onConfirm: () => Promise<void> | void;
  onClose: () => void;
}) {
  const [busy, setBusy] = React.useState(false);
  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div
        className="modal card fade-in"
        style={{ maxWidth: 420 }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-h">
          <div>
            <div className="modal-title">{title}</div>
          </div>
          <button className="icon-btn" onClick={onClose} aria-label="Close">
            <Icon name="x" size={14} />
          </button>
        </div>
        <div className="modal-body">
          <div style={{ fontSize: 13.5, color: "var(--ink-700)", lineHeight: 1.5 }}>{body}</div>
        </div>
        <div className="modal-foot">
          <button className="btn btn-secondary" onClick={onClose} disabled={busy}>Cancel</button>
          <button
            className={"btn " + (destructive ? "btn-danger" : "btn-primary")}
            disabled={busy}
            onClick={async () => {
              setBusy(true);
              try { await onConfirm(); } finally { setBusy(false); }
            }}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
